module.exports = __webpack_public_path__ + "img/branded-api-portal.73447e2f.png";